import { DS_ID } from 'src/constants/chart';

import assessmentDS from './assessmentDataDS';
import behaviorIncidentDS from './behaviorIncidentDataFlatDS';
import sessionDS from './sessionDataDS';
import sessionTrialDS from './sessionTrialDataDS';
import targetsDS from './targetsDS';

/**
 * in case of need can be extended for better control of available data sources
 * one of options - adding scope/user permission based selection of DS to return
 */
export default class DataSourceManager {
  constructor(InsightsMixin) {
    this.dataSourceMap = {
      [DS_ID.ASSESSMENT]: assessmentDS,
      [DS_ID.BEHAVIOR_INCIDENT]: behaviorIncidentDS,
      [DS_ID.SESSION]: sessionDS,
      [DS_ID.SESSION_TRIAL]: sessionTrialDS,
      [DS_ID.TARGETS]: targetsDS,
    };

    this.defaultDataSources = Object.values(DS_ID);
    this.mixin = InsightsMixin;
  }

  // eslint-disable-next-line class-methods-use-this
  #loadDataSource(ds, mixin) {
    return ds.apply(mixin);
  }

  getAvailableDataSources(dsKeyArray = this.defaultDataSources) {
    const dataSources = dsKeyArray.filter((key) => {
      return !!(key && this.dataSourceMap[key]);
    }).map((key) => {
      return this.#loadDataSource(this.dataSourceMap[key], this.mixin);
    });

    return dataSources;
  }
}
